/**
 * Shape Library - Auto-generated Shape Registry
 *
 * Total Shapes: 41
 * Categories: Basic, Flowchart, Arrows & Lines, Text & Annotations, Miscellaneous
 *
 * @generated - DO NOT EDIT MANUALLY
 * Run 'npm run generate:shapes' to regenerate this file
 */

export type ShapeCategory = 'basic' | 'flowchart' | 'text-annotations' | 'misc';

export interface ShapeDefinition {
  id: string;
  name: string;
  category: ShapeCategory;
  path: string;
  tags: string[];
}

// ============================================================================
// Category Metadata
// ============================================================================

export const CATEGORY_METADATA = {
  'basic': {
    name: 'Basic Shapes',
    color: '#6B7280',
    description: 'Fundamental geometric shapes',
    shapeCount: 14,
  },
  'flowchart': {
    name: 'Flowchart',
    color: '#3B82F6',
    description: 'Standard flowchart symbols',
    shapeCount: 12,
  },
  'text-annotations': {
    name: 'Text & Annotations',
    color: '#10B981',
    description: 'Text boxes and callouts',
    shapeCount: 5,
  },
  'misc': {
    name: 'Miscellaneous',
    color: '#F59E0B',
    description: 'Additional shapes and elements',
    shapeCount: 10,
  },
} as const;

// ============================================================================
// Shape Registry (41 shapes)
// ============================================================================

export const SHAPE_REGISTRY: Record<string, ShapeDefinition> = {
  // Basic Shapes (14 shapes)
  'basic-circle': {
    "id": "basic-circle",
    "name": "Circle",
    "category": "basic",
    "path": "/shapes/basic/circle.svg",
    "tags": [
      "basic",
      "circle",
      "round"
    ]
  },
  'basic-cross': {
    "id": "basic-cross",
    "name": "Cross",
    "category": "basic",
    "path": "/shapes/basic/cross.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-diamond': {
    "id": "basic-diamond",
    "name": "Diamond",
    "category": "basic",
    "path": "/shapes/basic/diamond.svg",
    "tags": [
      "basic",
      "diamond",
      "decision"
    ]
  },
  'basic-ellipse': {
    "id": "basic-ellipse",
    "name": "Ellipse",
    "category": "basic",
    "path": "/shapes/basic/ellipse.svg",
    "tags": [
      "basic",
      "circle",
      "round"
    ]
  },
  'basic-hexagon': {
    "id": "basic-hexagon",
    "name": "Hexagon",
    "category": "basic",
    "path": "/shapes/basic/hexagon.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-octagon': {
    "id": "basic-octagon",
    "name": "Octagon",
    "category": "basic",
    "path": "/shapes/basic/octagon.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-parallelogram': {
    "id": "basic-parallelogram",
    "name": "Parallelogram",
    "category": "basic",
    "path": "/shapes/basic/parallelogram.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-pentagon': {
    "id": "basic-pentagon",
    "name": "Pentagon",
    "category": "basic",
    "path": "/shapes/basic/pentagon.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-rectangle': {
    "id": "basic-rectangle",
    "name": "Rectangle",
    "category": "basic",
    "path": "/shapes/basic/rectangle.svg",
    "tags": [
      "basic",
      "rectangle",
      "box"
    ]
  },
  'basic-rounded-rectangle': {
    "id": "basic-rounded-rectangle",
    "name": "Rounded Rectangle",
    "category": "basic",
    "path": "/shapes/basic/rounded-rectangle.svg",
    "tags": [
      "basic",
      "rectangle",
      "box"
    ]
  },
  'basic-square': {
    "id": "basic-square",
    "name": "Square",
    "category": "basic",
    "path": "/shapes/basic/square.svg",
    "tags": [
      "basic",
      "rectangle",
      "box"
    ]
  },
  'basic-star': {
    "id": "basic-star",
    "name": "Star",
    "category": "basic",
    "path": "/shapes/basic/star.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-trapezoid': {
    "id": "basic-trapezoid",
    "name": "Trapezoid",
    "category": "basic",
    "path": "/shapes/basic/trapezoid.svg",
    "tags": [
      "basic",
      "shape"
    ]
  },
  'basic-triangle': {
    "id": "basic-triangle",
    "name": "Triangle",
    "category": "basic",
    "path": "/shapes/basic/triangle.svg",
    "tags": [
      "basic",
      "triangle",
      "arrow"
    ]
  },

  // Flowchart (12 shapes)
  'flowchart-data': {
    "id": "flowchart-data",
    "name": "Data",
    "category": "flowchart",
    "path": "/shapes/flowchart/data.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },
  'flowchart-database': {
    "id": "flowchart-database",
    "name": "Database",
    "category": "flowchart",
    "path": "/shapes/flowchart/database.svg",
    "tags": [
      "flowchart",
      "database",
      "storage"
    ]
  },
  'flowchart-decision': {
    "id": "flowchart-decision",
    "name": "Decision",
    "category": "flowchart",
    "path": "/shapes/flowchart/decision.svg",
    "tags": [
      "flowchart",
      "decision",
      "flowchart"
    ]
  },
  'flowchart-delay': {
    "id": "flowchart-delay",
    "name": "Delay",
    "category": "flowchart",
    "path": "/shapes/flowchart/delay.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },
  'flowchart-direct-access-storage': {
    "id": "flowchart-direct-access-storage",
    "name": "Direct Access Storage",
    "category": "flowchart",
    "path": "/shapes/flowchart/direct-access-storage.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },
  'flowchart-document': {
    "id": "flowchart-document",
    "name": "Document",
    "category": "flowchart",
    "path": "/shapes/flowchart/document.svg",
    "tags": [
      "flowchart",
      "document",
      "file"
    ]
  },
  'flowchart-internal-storage': {
    "id": "flowchart-internal-storage",
    "name": "Internal Storage",
    "category": "flowchart",
    "path": "/shapes/flowchart/internal-storage.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },
  'flowchart-manual-operation': {
    "id": "flowchart-manual-operation",
    "name": "Manual Operation",
    "category": "flowchart",
    "path": "/shapes/flowchart/manual-operation.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },
  'flowchart-multi-document': {
    "id": "flowchart-multi-document",
    "name": "Multi Document",
    "category": "flowchart",
    "path": "/shapes/flowchart/multi-document.svg",
    "tags": [
      "flowchart",
      "document",
      "file"
    ]
  },
  'flowchart-predefined-process': {
    "id": "flowchart-predefined-process",
    "name": "Predefined Process",
    "category": "flowchart",
    "path": "/shapes/flowchart/predefined-process.svg",
    "tags": [
      "flowchart",
      "process",
      "flowchart"
    ]
  },
  'flowchart-process': {
    "id": "flowchart-process",
    "name": "Process",
    "category": "flowchart",
    "path": "/shapes/flowchart/process.svg",
    "tags": [
      "flowchart",
      "process",
      "flowchart"
    ]
  },
  'flowchart-terminator': {
    "id": "flowchart-terminator",
    "name": "Terminator",
    "category": "flowchart",
    "path": "/shapes/flowchart/terminator.svg",
    "tags": [
      "flowchart",
      "shape"
    ]
  },

  // Text & Annotations (5 shapes)
  'text-annotations-banner': {
    "id": "text-annotations-banner",
    "name": "Banner",
    "category": "text-annotations",
    "path": "/shapes/text-annotations/banner.svg",
    "tags": [
      "text-annotations",
      "shape"
    ]
  },
  'text-annotations-callout': {
    "id": "text-annotations-callout",
    "name": "Callout",
    "category": "text-annotations",
    "path": "/shapes/text-annotations/callout.svg",
    "tags": [
      "text-annotations",
      "shape"
    ]
  },
  'text-annotations-cloud': {
    "id": "text-annotations-cloud",
    "name": "Cloud",
    "category": "text-annotations",
    "path": "/shapes/text-annotations/cloud.svg",
    "tags": [
      "text-annotations",
      "shape"
    ]
  },
  'text-annotations-note-sticky': {
    "id": "text-annotations-note-sticky",
    "name": "Note Sticky",
    "category": "text-annotations",
    "path": "/shapes/text-annotations/note-sticky.svg",
    "tags": [
      "text-annotations",
      "text",
      "annotation"
    ]
  },
  'text-annotations-text-block': {
    "id": "text-annotations-text-block",
    "name": "Text Block",
    "category": "text-annotations",
    "path": "/shapes/text-annotations/text-block.svg",
    "tags": [
      "text-annotations",
      "text",
      "annotation"
    ]
  },

  // Miscellaneous (10 shapes)
  'misc-brace': {
    "id": "misc-brace",
    "name": "Brace",
    "category": "misc",
    "path": "/shapes/misc/brace.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-bracket': {
    "id": "misc-bracket",
    "name": "Bracket",
    "category": "misc",
    "path": "/shapes/misc/bracket.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-cube-3d': {
    "id": "misc-cube-3d",
    "name": "Cube 3d",
    "category": "misc",
    "path": "/shapes/misc/cube-3d.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-cylinder': {
    "id": "misc-cylinder",
    "name": "Cylinder",
    "category": "misc",
    "path": "/shapes/misc/cylinder.svg",
    "tags": [
      "misc",
      "database",
      "storage"
    ]
  },
  'misc-file-document': {
    "id": "misc-file-document",
    "name": "File Document",
    "category": "misc",
    "path": "/shapes/misc/file-document.svg",
    "tags": [
      "misc",
      "document",
      "file"
    ]
  },
  'misc-folder': {
    "id": "misc-folder",
    "name": "Folder",
    "category": "misc",
    "path": "/shapes/misc/folder.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-image-frame': {
    "id": "misc-image-frame",
    "name": "Image Frame",
    "category": "misc",
    "path": "/shapes/misc/image-frame.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-list': {
    "id": "misc-list",
    "name": "List",
    "category": "misc",
    "path": "/shapes/misc/list.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-person-actor': {
    "id": "misc-person-actor",
    "name": "Person Actor",
    "category": "misc",
    "path": "/shapes/misc/person-actor.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },
  'misc-table-grid': {
    "id": "misc-table-grid",
    "name": "Table Grid",
    "category": "misc",
    "path": "/shapes/misc/table-grid.svg",
    "tags": [
      "misc",
      "shape"
    ]
  },

} as const;

// ============================================================================
// Helper Functions
// ============================================================================

/**
 * Get shape by ID
 */
export function getShape(shapeId: string): ShapeDefinition | undefined {
  return SHAPE_REGISTRY[shapeId];
}

/**
 * Get shape path by ID
 */
export function getShapePath(shapeId: string): string | undefined {
  return SHAPE_REGISTRY[shapeId]?.path;
}

/**
 * Get category color
 */
export function getCategoryColor(category: ShapeCategory): string {
  return CATEGORY_METADATA[category]?.color || '#6B7280';
}

/**
 * Search shapes by query (searches name and tags)
 */
export function searchShapes(query: string): ShapeDefinition[] {
  const lowerQuery = query.toLowerCase().trim();
  if (!lowerQuery) return [];

  return Object.values(SHAPE_REGISTRY).filter((shape) =>
    shape.name.toLowerCase().includes(lowerQuery) ||
    shape.tags.some((tag) => tag.toLowerCase().includes(lowerQuery)) ||
    shape.id.toLowerCase().includes(lowerQuery)
  );
}

/**
 * Get all shapes for a category
 */
export function getShapesByCategory(category: ShapeCategory): ShapeDefinition[] {
  return Object.values(SHAPE_REGISTRY).filter((shape) => shape.category === category);
}

/**
 * Get all categories
 */
export function getAllCategories(): ShapeCategory[] {
  return Object.keys(CATEGORY_METADATA) as ShapeCategory[];
}

/**
 * Get all shapes
 */
export function getAllShapes(): ShapeDefinition[] {
  return Object.values(SHAPE_REGISTRY);
}

/**
 * Get random shapes (for testing/demo)
 */
export function getRandomShapes(count: number = 10): ShapeDefinition[] {
  const allShapes = Object.values(SHAPE_REGISTRY);
  const shuffled = [...allShapes].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
}
